<template>
  <div
    :class="['map-wrap', {'shift-right': shiftMap}]"
    @click="clearDestinations"
  >
    <svg
      :viewBox="viewBox"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      height="100%"
      width="100%"
    >
      <!-- NOTE: 地図画像 -->
      <map-image />

      <!-- NOTE: サイネージの場所ピン -->
      <image
        width="90"
        height="99"
        :transform="`translate(13, -19.5) scale(${pxToSvgSize(90) / 90})`"
        xlink:href="~@/assets/images/current_location.svg"
      />
    </svg>

    <!-- NOTE: heatmap.jsを使う見える化レイヤー -->
    <visualization-layer-congestion v-if="visualizationLayerType === 'congestion'" />

    <svg
      :viewBox="viewBox"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      height="100%"
      width="100%"
      class="visualizationPinLayer"
    >
      <svg-defs />

      <!-- NOTE: 見える化レイヤー -->
      <visualization-layer-setstar v-if="visualizationLayerType == 'setstar'" />
      <visualization-layer-sound v-if="visualizationLayerType == 'sound'" />

      <!-- NOTE: ピン -->
      <visualization-pin-spot v-if="includesSpotsPin" />
      <visualization-pin-person v-if="includesPersonsPin" />

    </svg>
  </div>
</template>

<script>
// TODO: データ取得できるようになったら消す
import stubContours from '@/stub_contours.js';

import map from '@/mixins/map.js';

import svgDefs from './decoration/defs.vue';
import mapImage from './map_image.vue';
import visualizationPinSpot from './visualization/pin/spot.vue';
import visualizationPinPerson from './visualization/pin/person.vue';
import visualizationLayerCongestion from './visualization/layer/congestion.vue';
import visualizationLayerSetstar from './visualization/layer/setstar.vue';
import visualizationLayerSound from './visualization/layer/sound.vue';

// TODO: データ取得できるようになったら消す
export default {
  components: {
    svgDefs,
    mapImage,
    visualizationPinSpot,
    visualizationPinPerson,
    visualizationLayerCongestion,
    visualizationLayerSetstar,
    visualizationLayerSound,
  },
  mixins: [map],
  data() {
    return {
      getContoursTimer: null,
    };
  },
  computed: {
    currentFloor: ({ $store, currentFloorId }) => $store.getters['area/floorFind'](currentFloorId),
    currentFloorId: ({ $store }) => $store.state.current.floorId,
    currentBuilding: (vm) => vm.$store.getters['area/buildingFindByFloor'](vm.currentFloorId),
    currentBuildingId: ({ $store }) => $store.state.current.buildingId,
    svgElm: {
      get: ({ $store }) => $store.state.map.svgElm,
      set(elm) {
        this.$store.commit('map/getSvgElm', elm);
      },
    },
    viewBox: ({ currentBuilding }) => `0 -${currentBuilding.depth} ${currentBuilding.width} ${currentBuilding.depth}`,
    visualizationLayerType: ({ $store }) => $store.state.map.visualizationLayerType,
    visualizationPinType: ({ $store }) => $store.state.map.visualizationPinType,
    isShowDetail: ({ $store }) => $store.state.destinationDetail.isShow,
    shiftMap: ({ $store }) => $store.state.map.shiftMap,
    includesSpotsPin: ({ $store }) => $store.getters['map/includesSpotsPin'],
    includesPersonsPin: ({ $store }) => $store.getters['map/includesPersonsPin'],
  },
  watch: {
    currentFloorId(id) {
      const building = this.$store.getters['area/buildingFindByFloor'](id);
      this.$store.commit('current/setBuildingId', building.id);
      this.$store.dispatch('area/getFloorSpots', id);
      this.getDomInfomation();
      this.svgElm.style.opacity = 0;
      setTimeout(() => {
        this.svgElm.style.transition = 'opacity 0.5s linear';
        this.svgElm.style.opacity = 1;
        setTimeout(() => {
          this.svgElm.removeAttribute('style');
        }, 500);
      }, 0);
    },
    visualizationLayerType(type) {
      if (type === 'temperature') {
        this.getContoursTimer = setInterval(() => {
          const contoursData = this.$store.state.contours.contoursData === stubContours.values1 ? stubContours.values2 : stubContours.values1;
          this.$store.commit('contours/setContoursData', contoursData);
        }, 3000);
      } else {
        clearInterval(this.getContoursTimer);
      }
    },
  },
  created() {
    // NOTE: TAC.T CAFE & TAC.T TERRACE 固定表示なのでIDは固定値
    const floorID = 1;
    this.$store.commit('current/setFloorId', floorID);
  },
  mounted() {
    this.svgElm = this.$el.querySelector('svg');
    this.getDomInfomation();
  },
  methods: {
    getDomInfomation() {
      this.$store.dispatch('map/getFitOrientation');
      this.$store.dispatch('map/saveBaseDomRect');
    },
    clearDestinations() {
      this.$store.dispatch('searchResult/allClearDestinations');
    },
  },

};
</script>

<style scoped lang="scss">
svg {
  display: block;
  box-sizing: border-box;
  transform-origin: 0 0;
}
.visualizationPinLayer {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
}
.map-wrap {
  height: 100%;
  width: 100%;
  transition: transform 0.2s ease-out 0;
  &.shift-right {
    transform: translateX(550px);
  }
}
</style>



// WEBPACK FOOTER //
// map.vue?5c1566a8